import React from "react";
import { useNavigate } from 'react-router-dom';
import { checkEmail } from '../services/Mail_service';
import { getUserIdByEmail } from '../services/Passwoard_service'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';
import logo from '../image/logo.png';
import test1 from '../image/image.gif';
import { useForm, SubmitHandler } from "react-hook-form";

type Inputs = {
email: string;
};

const Mail: React.FC = () => {
const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
    const navigate = useNavigate();

    const onSubmit: SubmitHandler<Inputs> = async (data: Inputs) => {
        try {
        // Vérification de l'email
        await checkEmail(data.email);

        // Récupération de l'ID utilisateur
        const response = await getUserIdByEmail(data.email);
        const userId = response.id;

        // Stockage de l'email et de l'ID utilisateur
        localStorage.setItem('email', data.email);
        localStorage.setItem('userId', userId);

        // Redirection vers la page de code de vérification
        navigate('/code');
        } catch (error: any) {
        console.error('Erreur lors de l\'envoi de l\'email de vérification ou récupération de l\'ID:', error);
        toast.error('Votre mail est invalide');
        }
        };

        return (
        <>
            <ToastContainer />
            <div className="degrade-vertical big-height">
                {/* logo */}
                <div className="row d-flex justify-content-center align-items-center vh-100">
                    <div className="col-md-6 col-sm-12 d-flex section-txt">
                    <div className="bg-section">
                            <div className="img-animate mb-5">
                                <img src={test1} alt="gif" className="img-fluid w-100 " />
                            </div>
                            <div className="text-title pt-5 ">
                                <h1 className="font-1">Annonce Legale Officielle</h1>
                                <p className="font-2 ">Bénéficiez d’une publication instantanée dans toute la France,
                                    grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout type
                                    d’annonce, des plus simples aux plus complexes.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12  bg-dark-login d-flex section-txt">
                        <div className="p-3 text-center">
                            <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                        </div>
                        <form className="form-login pb-4 px-5 pt-4 d-flex" onSubmit={handleSubmit(onSubmit)}>
                            <p className="txt-login mb-4">Veuillez entrer votre adresse e-mail</p>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"
                                        style={{ color: '#919394' }}>@</span>
                                </div>
                                <input type="email" className="form-control" placeholder="email" aria-label="email"
                                    aria-describedby="basic-addon1" {...register('email', { required: 'Email est requis'
                                    })} />
                            </div>
                            {errors.email && <p className="error-message">{errors.email.message}</p>}
                            <button type="submit" className="btn btn-1">Envoyer</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
        );
        };

        export default Mail;